<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>

    <div class="container" style="margin-top:10px" >
        <div class="row" *ngIf="breedinfo" >
            <div class="col-12 col-md-6 col-lg-3 col-xl-3" *ngFor="let data of breedinfo">
                <div class="single_catagory wow fadeInUp" >
                    <img style="width:100%; height:180px" src="https://passport.petcart.in/images/breedimages/{{data.image}}" alt="">
                    <div class="catagory-title">
                        <a>
                            <h5 routerLink="/breed/info/{{data.id}}/{{data.name}}">{{data.name}}</h5>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>